export default __webpack_public_path__ + "static/media/iwatchtv-dark-logo-V2.c52620db.png";